// Updates sections outside the main product section when a variant changes.
// Listens for the theme's variant:update event and morphs matching sections
// from the response HTML.

const SECTION_SUFFIXES = [
  'box-info',
  'bag-page-split',
  'bag-page-split-reverse',
];

document.addEventListener('variant:update', (event) => {
  const html = event.detail?.data?.html;
  if (!html) return;

  SECTION_SUFFIXES.forEach((suffix) => {
    const currentEl = document.querySelector(`[id$="__${suffix}"]`);
    const newEl = html.querySelector(`[id$="__${suffix}"]`);
    if (currentEl && newEl) {
      currentEl.innerHTML = newEl.innerHTML;
    }
  });
});
